module.exports = __webpack_public_path__ + "media/images/icn-plus-14d46fc568450530d5d512d54aa4a3a8.png";